import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import classNames from 'classnames';
import { createPortal } from 'react-dom';
import { UIActions } from '../../ui/uiSlice';
import useAppSelector, { useAppDispatch } from '../redux/useAppSelector';
import styles from './RightPanelContainer.module.scss';

interface RightPanelContainerProps {
  shiftContent: boolean;
}

const RightPanelContainer = ({ shiftContent }: RightPanelContainerProps) => {
  const { isOpen, View, props } = useAppSelector(
    (state) => state.ui.rightPanel,
  );
  const dispatch = useAppDispatch();

  const inner = (
    <div
      data-no-print
      className={classNames(styles.rightPanelContainer, {
        [styles.isOpen]: isOpen,
        [styles.shiftContent]: shiftContent,
      })}
    >
      <AnimatePresence>
        {isOpen && (
          <motion.div
            key="view-container"
            initial={{ opacity: 0 }}
            exit={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className={styles.viewContainer}
          >
            {View && (
              <View
                close={() => dispatch(UIActions.closeRightPanel())}
                {...props}
              />
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );

  return shiftContent ? createPortal(inner, document.body) : inner;
};

export default RightPanelContainer;
